import styled, { css } from 'styled-components';

export const Header = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.sz.s1};
  `,
);

export const Title = styled.h2(
  ({ theme }) => css`
    ${theme.typography.heading.desktop.xxs};
    margin: 0;
    color: ${theme.co.neutral10};
  `,
);

export const Description = styled.p(
  ({ theme }) => css`
    ${theme.typography.paragraph.s};
    margin: 0;
    color: ${theme.co.neutral30};
  `,
);

export {
  OptionButton,
  OptionDescription,
  OptionIcon,
  OptionsList,
  OptionText,
  OptionTitle,
} from '../sharedStyles';
